<template>
  <div class="h-120px flex">
    <div :key="index" v-for="(item, index) in data" class="flex-auto flex items-center">
      <div class="flex-auto flex items-center">
        <i
          class="p-10px iconfont icon-bg-model text-50px mx-20px text-white rounded"
          :style="{ background: item.color }"
        ></i>
        <div class="pr-20px">
          <span :style="{ color: item.color }"> {{ item.value + (item.unit || '') }}</span>
          <p class="text-trueGray-400">{{ item.label }}</p>
        </div>
      </div>
      <div class="h-52px w-1px bg-gray-400" v-if="index < data.length - 1"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'kpi-list',
  props: {
    data: {
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss"></style>
